export class Timezone {
	label: string
	value: string

	constructor(data: { label: string; value: string }) {
		this.label = data.label
		this.value = data.value
	}

	static create(data: Partial<Timezone>) {
		const defaultData = {
			label: '',
			value: '',
		}
		return new Timezone({ ...defaultData, ...data })
	}
}
